import * as Backbone from "backbone";

interface SensorConfigRecord {
    connector: number;
    created: string;
    hash_order: number;
    id: number;
    modified: string;
    module_id: number;
    num_bits: number;
    order: number;
    sensor_id: number;
    sensor_type: number;
    sensor_version: number;
    type: string;
    value: number;
}


export class SensorConfig extends Backbone.Model {
    attributes: SensorConfigRecord;
}


// WEBPACK FOOTER //
// ./srv/public/js/models/SensorConfig.ts